<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->

<div class="users-panel">
    <h3 *ngIf="baseUrl$ | async as baseUrl" windeGridTitle>
        <strong>{{ 'user-grid.title.' + baseUrl | translate }}</strong>
        <winde-ctx-sensitive-help
                *ngIf="showEditBtn$ | async"
                [routerLink]="['', { outlets: { popup: [action.CREATE, baseUrl] } }]"
                [tooltipTextPath]="'user.grid.' + baseUrl + '.addUser'"
                placement="right"
                queryParamsHandling="preserve"
        >
            <sui-svg-icon icon="user-plus" windeGreen/>
        </winde-ctx-sensitive-help>
    </h3>

    <winde-users-grid></winde-users-grid>
</div>
